// extracted by mini-css-extract-plugin
export default {"feedItem":"FeedItem-module__feedItem___naBz8","image":"FeedItem-module__image___eLIB4","title":"FeedItem-module__title___7hccI"};